import type { CountryCode } from '~/core/i18n/types'
import { COUNTRY_CODE } from '~/core/i18n/constants/countryCode'
import { MT_APP_URL } from '~/core/i18n/constants'

export default function getCountryFromUrl({ hostname }: { hostname: string }): CountryCode | null {
  const toHostName = (url: string) => url ? new URL(url).hostname : ''

  switch (hostname) {
    case toHostName(MT_APP_URL[COUNTRY_CODE.RU]):
      return COUNTRY_CODE.RU
    case toHostName(MT_APP_URL[COUNTRY_CODE.AM]):
      return COUNTRY_CODE.AM
    case toHostName(MT_APP_URL[COUNTRY_CODE.BY]):
      return COUNTRY_CODE.BY
    case toHostName(MT_APP_URL[COUNTRY_CODE.GE]):
      return COUNTRY_CODE.GE
    case toHostName(MT_APP_URL[COUNTRY_CODE.KG]):
      return COUNTRY_CODE.KG
    case toHostName(MT_APP_URL[COUNTRY_CODE.KZ]):
      return COUNTRY_CODE.KZ
    case toHostName(MT_APP_URL[COUNTRY_CODE.MD]):
      return COUNTRY_CODE.MD
    case toHostName(MT_APP_URL[COUNTRY_CODE.TJ]):
      return COUNTRY_CODE.TJ
    case toHostName(MT_APP_URL[COUNTRY_CODE.UZ]):
      return COUNTRY_CODE.UZ
    case toHostName(MT_APP_URL[COUNTRY_CODE.other]):
      return COUNTRY_CODE.other
    default:
      return null
  }
}
